"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
exports.default = {
    [constants_1.MarkTypeMap.STRONG]: {
        parseDOM: [{ tag: 'strong, b' }],
        toDOM() {
            return ['strong', { class: 'is-bold' }, 0];
        },
    },
    [constants_1.MarkTypeMap.EM]: {
        parseDOM: [{ tag: 'em, i' }],
        toDOM() {
            return ['em', { class: 'is-italic' }, 0];
        },
    },
    [constants_1.MarkTypeMap.UNDERLINE]: {
        parseDOM: [{ tag: 'u' }],
        toDOM() {
            return ['u', { class: 'is-underlined' }, 0];
        },
    },
    // adapted from https://github.com/ProseMirror/prosemirror-schema-basic/blob/669e5d01bf1f9259bc511e4af58b5d56ecad15a6/src/schema-basic.js#L113-L123
    [constants_1.MarkTypeMap.LINK]: {
        attrs: {
            href: {},
            autolink: { default: true },
        },
        inclusive: false,
        parseDOM: [
            {
                tag: 'a[href]',
                getAttrs(dom) {
                    return { href: dom.getAttribute('href') };
                },
            },
        ],
        toDOM(node) {
            const { href } = node.attrs;
            return ['a', { href, target: '_blank' }, 0];
        },
    },
    [constants_1.MarkTypeMap.COMMENT]: {
        attrs: {
            id: { default: null },
            resolved: { default: false },
        },
        // mark should not be active when cursor is positioned at its end
        inclusive: false,
        // allow multiple marks with different types to coexist
        excludes: '',
        // previously we stripped comment marks when the dom was parsed.
        // now we rely on our paste handler to ensure that only marks
        // that were cut/pasted in the same document are allowed through
        parseDOM: [
            {
                tag: 'span.e-comment',
                getAttrs(dom) {
                    return {
                        id: dom.getAttribute('id'),
                        resolved: !dom.classList.contains('is-highlighted'),
                    };
                },
            },
        ],
        toDOM(node) {
            const { id, resolved } = node.attrs;
            return [
                'span',
                { id, class: `e-comment${resolved ? '' : ' is-highlighted'}` },
                0,
            ];
        },
    },
    [constants_1.MarkTypeMap.STRIKE]: {
        parseDOM: [{ tag: 's' }],
        toDOM() {
            return ['s', 0];
        },
    },
};
